import React from "react";
import { useTheme } from "../../../contexts/ThemeContext";

interface PageHeaderProps {
  title: string;
  description?: string;
  children?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  description,
  children,
}) => {
  const { theme } = useTheme();

  return (
    <header
      className={`py-10 md:py-14 border-b border-border-primary ${
        theme.mode === "dark" ? "bg-surface-secondary" : "bg-text-primary"
      }`}
    >
      <div className="container mx-auto lg:max-w-7xl px-4 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <h1
            className={`text-4xl md:text-5xl font-major mb-1 leading-none ${
              theme.mode === "dark" ? "text-text-primary" : "text-text-inverse"
            }`}
          >
            {title}
          </h1>
          {description && (
            <p
              className={`mb-8 md:mb-12 md:text-2xl font-light ${
                theme.mode === "dark"
                  ? "text-text-secondary"
                  : "text-text-inverse"
              }`}
            >
              {description}
            </p>
          )}
          {children}
        </div>
      </div>
    </header>
  );
};

export default PageHeader; 